import authAxios from 'src/modules/shared/axios/authAxios';



export default class EntitlementService {
  static async list(renewalPeriod) {
    const response = await authAxios.get(
      `/entitlement/source`,
      {
        params: {
          source: 'Stripe',
          currency:"USD",
          renewalPeriod:renewalPeriod,
          title:"Full Access"
        },
      },
    );

    return response.data;
  }
  

  static async getPaymentIntent(data) {
    
    try {
      const response = await authAxios.post(`/plan/stripe/createSubscription`, data)
      return response;
      
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  }
  static async cancelSubscription(data) {
    
    try {
      const response = await authAxios.post(`/plan/stripe/cancleSubscription`, data)
      return response;
      
    } catch (error) {
      console.error(error);
    }
  }
  

  static async setUpIntent() {
    
    try {
      const response = await authAxios.get(`/plan/stripe/setupIntent`)
      return response;
      
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  }
  static async getClientSecret() {
    
    try {
      const response = await authAxios.get(`/plan/stripe/getCredentialsStripe`)
      return response;
      
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  }
  static async payment(data) {
    
    try {
      const response = await authAxios.post(`/plan/stripe/customerAddPaymentMethod`, data)
      return response;
      
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  }
  static async switchPlan(data) {
    
    try {
      const response = await authAxios.post(`/plan/stripe/switchPlan`, data)
      return response;
      
    } catch (error) {
      console.error("Error fetching products:", error);
  
    }
  }
  static async updateSubscription (){
    try {
      const response = await authAxios.get(`/plan/stripe/updateSubscription`)
      return response;
      
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  }
}
